export const uuid = (noDashes: boolean = true) =>
    noDashes ? crypto.randomUUID().replace(/-/g, '') : crypto.randomUUID();

export const isGuidWithoutDashes = (str?: string | null) => {
    if (!str) return false;
    const regex = /^[0-9a-fA-F]{32}$/;
    return regex.test(str);
};
